import { assertNever } from '@eversports/utility-types'
import React from 'react'

import { RequiredInformationType } from '../../../typings/AdditionalInformation'

import Address from './Address'
import Birthday from './Birthday'
import FiscalCode from './FiscalCode'
import PhoneNumber from './PhoneNumber'

interface Props {
  requiredInformationType: RequiredInformationType
}

const RequiredInformationTypeMapper: React.FC<React.PropsWithChildren<Props>> = ({ requiredInformationType }) => {
  switch (requiredInformationType) {
    case RequiredInformationType.REQUIRED_INFORMATION_TYPE_ADDRESS:
      return <Address />
    case RequiredInformationType.REQUIRED_INFORMATION_TYPE_BIRTHDAY:
      return <Birthday />
    case RequiredInformationType.REQUIRED_INFORMATION_TYPE_PHONE_NUMBER:
      return <PhoneNumber />
    case RequiredInformationType.REQUIRED_INFORMATION_TYPE_FISCAL_CODE:
      return <FiscalCode />
    default:
      return assertNever(requiredInformationType)
  }
}

export default RequiredInformationTypeMapper
